// src/pages/PaymentCancel.jsx
import { Link } from 'react-router-dom';
import { Ban, ArrowLeft, ShoppingBag } from 'lucide-react';

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-yellow-50 to-yellow-100 dark:from-yellow-900/20 dark:to-yellow-800/10 flex items-center justify-center p-4">
      <div className="bg-white dark:bg-slate-900 rounded-2xl shadow-2xl p-8 max-w-md w-full text-center">
        <Ban className="w-16 h-16 text-yellow-500 mx-auto mb-6" />
        
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
          Payment Cancelled
        </h1>
        
        <p className="text-gray-600 dark:text-gray-400 mb-6">
          Your payment was cancelled. No charges have been made to your account.
        </p>

        <div className="space-y-3">
          <button
            onClick={() => window.history.back()}
            className="w-full btn-primary flex items-center justify-center gap-2"
          >
            <ShoppingBag className="w-5 h-5" />
            Continue Booking
          </button>
          
          <Link
            to="/tours"
            className="w-full btn-secondary flex items-center justify-center gap-2"
          >
            <ArrowLeft className="w-5 h-5" />
            Browse Other Tours
          </Link>
        </div>
      </div>
    </div>
  );
}